import { render, staticRenderFns } from "./FeaturedProjectsSlide.vue?vue&type=template&id=0b98d47b"
import script from "./FeaturedProjectsSlide.vue?vue&type=script&lang=js"
export * from "./FeaturedProjectsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports